import React, { useState, useEffect, useCallback } from "react";
import AWS from "aws-sdk";
import Slide from "@mui/material/Slide"; //import AddFlavorForm from "./AddFlavorForm";
import { ServiceApi } from "../services/index.service";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import EditIcon from "@mui/icons-material/Edit";
// import { useSelector } from "react-redux";
import {
  Autocomplete,
  Backdrop,
  Button,
  CircularProgress,
  DialogActions,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FlavorTabShimmer from "./FlavorTabShimmer";
import { useSnackbar } from "notistack";
import {
  CheckCircle,
  DeleteOutlineSharp,
  Preview,
  PreviewRounded,
} from "@mui/icons-material";
import RecipeCardPreview from "./RecipeCardPreview";
import { useSelector } from "react-redux";
import { CUSTARD_CATEGORY, HAND_SCOOPED_CUSTARD_CATEGORY, NOVELTY_CUSTARD_CATEGORY } from "../utils/constants";

// import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
// import StorefrontIcon from "@mui/icons-material/Storefront";
// import LoadingSpinner from "../utils/LoadingSpinner";
// import { storeSet } from "../redux/store/storeSlice";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
  region: process.env.REACT_APP_AWS_REGION,
});
// function classNames(...classes) {
//   return classes.filter(Boolean).join(" ");
// }
// const Transition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="up" ref={ref} {...props} />;
// });

function ManageFlavors() {
  const s3 = new AWS.S3();

  const { enqueueSnackbar } = useSnackbar();
  // const { storage } = useSelector((state) => state);
  const imageInputRef = React.useRef();
  const dtImageInputRef = React.useRef();
  const data = useSelector((state) => state);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [flavorLoading, setFlavorLoading] = useState(true);
  const [isUpdImagechanged, setIsUpdImageChanged] = useState(false);
  const [filterProductType, setFilterProductType] = useState("");
  const [testDialog, setTestDialog] = useState(false);
  const [storeList, setStoreList] = React.useState([]);
  const [selectedStoresForTest, setSelectedStoresForTest] = useState([])
  //handle flavors
  const [action, setAction] = React.useState("");
  // const [flavors, setFlavors] = React.useState([]);
  const [flavorsList, setFlavorsList] = React.useState([]);
  const [file, setFile] = React.useState("");
  // const [fileName, setFileName] = React.useState("");
  const [image, setImage] = useState("");
  const [dtFile, setDTFile] = React.useState("");
  const [dtImage, setDTImage] = useState("");
  const initialRecipe = {
    quarterContainer: "",
    halfContainer: "",
    singleContainer: "",
    doubleContainer: "",
  }
  const [recipeImage, setRecipeImage] = useState(initialRecipe);
  const [imageurl, setImageurl] = useState("");
  const [dtImageUrl, setDTImageUrl] = useState("");
  const [selectFlavor, setselectFlavor] = React.useState([]);
  const [productType, setProductType] = useState("");
  const [flavorName, setFlavorName] = useState("");
  const [receiptName, setReceiptName] = useState("");
  const [activeStatus, setActiveStatus] = useState(false);
  const [bitLTOStatus, setBitLTO] = useState(false);
  const [bitDisplayToppingIconStatus, setBitDisplayToppingIcon] = useState(false);
  const [bitIsOptionalStatus, setBitIsOptional] = useState(false);
  const [bitIsNutfreeStatus, setBitIsNutfree] = useState(false);
  const [bitIsKosherStatus, setBitIsKosher] = useState(false);
  const [bitIsCYKosherStatus, setBitIsCYKosher] = useState(false);
  const [flavorSearch, setFlavorSearch] = useState("");
  // const [s3Uri, setS3Uri] = useState("");
  const [flavorID, setFlavorID] = useState("");
  const [fID, setFID] = useState("");
  // error handling
  const [onFileSelectError, setOnFileSelectError] = useState("");
  const [onRecipeFileSelectError, setOnRecipeFileSelectError] = useState({
    quarterContainer: "",
    halfContainer: "",
    singleContainer: "",
    doubleContainer: "",
  });
  const [isSelected, setIsSelected] = useState("");
  const [isLabelFilled, setIsLabelFilled] = useState("");
  const [isReceiptFilled, setIsReceiptFilled] = useState("");
  const serviceapi = new ServiceApi();
  const [params, setParams] = useState({ keyword: "", productID: 0, activeFlag: true });

  const [showRecipeCards, setShowRecipeCards] = useState(false);
  const [selectedFlavor, setSelectedFlavor] = useState(null);
  useEffect(() => {
    setFlavorSearch("");
    getFlavors();
    getProductTypes();
    setOpen(false);
    getStores();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getFlavors();
  }, [params]);

  const getStores = async () => {
    try {
      const req = {
        fsm_name: "all",
        role: data?.profile?.role,
        user_name: data?.profile?.user_name,
      };
      const response = await serviceapi.fetchFCStores(req);
      setStoreList(response);
    } catch (e) {
      console.log(e);
    }
  };

  const getProductTypes = async () => {
    const response = await serviceapi?.fetchProductTypes();
    setselectFlavor(response);
  };

  const getFlavors = async () => {
    try {
      setFlavorLoading(true);
      let req = JSON.parse(JSON.stringify(params));
      if (req.productID === 0) {
        req.productID = "";
      }
      req.key = "recpie_cards";
      const response = await serviceapi?.fetchManageFlavors(req);

      // const uniqueTags = [];
      // response.map((item) => {
      //   var i = uniqueTags.findIndex(
      //     (x) => x.intProductTypeID === item.intProductTypeID
      //   );
      //   if (i <= -1) {
      //     uniqueTags.push(item);
      //   }
      //   return null;
      // });
      // let cat = [...new Set(response)];
      // setselectFlavor(uniqueTags);
      // setFlavors([]);
      // setFlavors(response);
      setFlavorsList([]);
      setFlavorsList(response);
      setFlavorLoading(false);
      // setTimeout(() => {
      // if (filterProductType && filterProductType !== "") {
      //   const tempFlavors = response.filter((item) => {
      //     return item.intProductTypeID === filterProductType;
      //   });
      //   setFlavorsList(tempFlavors);
      // }
      // }, 1000);
    } catch (e) {
      setFlavorLoading(false);
      console.log(e);
    }
  };

  // const getFileDownloadLink = async () => {
  //   try {
  //     const response = await serviceapi?.fetchManageFlavorsFileDownloadURL();
  //     let urlArray = response.s3_uri.split("/");
  //     setS3Uri(urlArray[3]);
  //   } catch (error) {
  //     console.log(error, " :: error");
  //   }
  // };

  const handleDownload = async () => {
    try {
      let req = JSON.parse(JSON.stringify(params));
      if (req.productID === 0) {
        req.productID = "";
      }
      req.key = "recpie_cards";
      const response = await serviceapi?.fetchManageFlavorsFileDownloadURL(req);
      if (response.statusCode === 200) {
        let urlArray = response.s3_uri.split("/");
        // console.log(urlArray, " url from s3 file download");
        // setS3Uri(urlArray[3]);
        let s3 = new AWS.S3({ params: { Bucket: process.env.REACT_APP_AWS_BUCKET } });
        const params = {
          Bucket: process.env.REACT_APP_AWS_BUCKET,
          Key: `${urlArray[3]}/${urlArray[4]}/${urlArray[5]}`,
        };
        s3.getObject(params, (err, data) => {
          let blob = new Blob([data.Body], { type: data.ContentType });
          const url = window.URL.createObjectURL(blob);
          const downloadLink = document.createElement("a");
          downloadLink.href = url;
          downloadLink.download = urlArray[5].substring(
            urlArray[5].lastIndexOf("/") + 1
          );
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        });
      } else {
        console.log(response, " :: error :: status code error");
      }
    } catch (error) {
      console.log(error, " :: error");
    }
  };

  // const getStores = async () => {
  //   try {
  //     const req = { fsm_name: "all" };
  //     const response = await serviceapi.fetchFCStores(req);
  //     console.log(response, "stores in Manage Flavors :::::", store);
  //     setStoreList(response);
  //     if (storage?.store) {
  //       setStore(storage?.store);
  //     }
  //   } catch (e) {
  //     console.log(e);
  //   }
  // };

  const callActions = (action, obj) => {
    setAction(action);
    setIsLabelFilled("");
    setIsReceiptFilled("");
    setIsSelected("");
    // setFileName("");
    setImage("");
    setFile("");
    setDTFile("");
    setImageurl("");
    setDTImage("");
    setDTImageUrl("");
    setReceiptName("");
    // setOnFileSelectError("");
    setActiveStatus(false);
    // imageInputRef.current.value = "";
    // console.log(action.trim(), "Action:", obj);
    if (action.trim() === "Add") {
      setProductType("");
      setFlavorName("");
      setImageurl("");
      setRecipeImage(initialRecipe)
    }
    if (action.trim() === "Edit") {
      setProductType(obj.intProductTypeID);
      setFlavorName(obj.flavor_name);
      setReceiptName(obj.receiptName);
      setActiveStatus(obj.activeFlag);
      setBitLTO(obj.bitLTO)
      setFlavorID(obj.intFlavorID);
      setFID(obj.fid);
      setImageurl(obj.imageURL);
      setDTImageUrl(obj.DTIconURL);
      setBitDisplayToppingIcon(obj.bitDisplayToppingIcon);
      setBitIsOptional(obj.bitIsOptional);
      setBitIsNutfree(obj.bitIsNutfree);
      setBitIsKosher(obj.bitIsKosher);
      setBitIsCYKosher(obj.bitIsCYKosher);
      if (obj.imageURL) {
        setImage(`${obj.imageURL}?rand=${Math.floor(Math.random() * 5557654)}`);
      }
      if (obj.DTIconURL) {
        setDTImage(`${obj.DTIconURL}?rand=${Math.floor(Math.random() * 5557654)}`);
      }
      const updateRecipeImage = {
        ...recipeImage,
        quarterContainer:
          obj?.quarterContainer === ""
            ? obj?.quarterContainer
            : getSignedUrl(obj?.quarterContainer),
        halfContainer:
          obj?.halfContainer === ""
            ? obj?.halfContainer
            : getSignedUrl(obj?.halfContainer),
        singleContainer:
          obj?.singleContainer === ""
            ? obj?.singleContainer
            : getSignedUrl(obj?.singleContainer),
        doubleContainer:
          obj?.doubleContainer === ""
            ? obj?.doubleContainer
            : getSignedUrl(obj?.doubleContainer),
      };
      setRecipeImage(updateRecipeImage)
    }

    setOpen(true);
  };

  const handleFileChange = (e, iconType) => {
    // e.preventDefault();
    if (!e.target.files) return;

    const file = e.target.files[0];

    // const formData = new FormData();
    // formData.append("image", file);
    // console.log(formData, "formdatas");

    if (action === "Edit") {
      setIsUpdImageChanged(true);
    }
    let fileSize = file?.size;
    fileSize = fileSize / 1048576;
    if (fileSize > 1) {
      // setOnFileSelectError(prevState => ({ ...prevState, [iconType]: "File size cannot exceed more than 1MB" }));
      enqueueSnackbar("File size cannot exceed more than 1MB", {
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "warning",
        autoHideDuration: 3000
      });
    } else {
      // setOnFileSelectError(prevState => ({ ...prevState, [iconType]: "" }));
      if (iconType === 'DT')
        setDTImage(URL.createObjectURL(file));
      else
        setImage(URL.createObjectURL(file));
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageData = reader.result;
        if (iconType === 'DT')
          setDTFile(imageData);
        else
          setFile(imageData);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRecipeFileChange = (e, name) => {
    // e.preventDefault();
    if (!e.target.files) return;

    const file = e.target.files[0];
    setOnRecipeFileSelectError({ ...onRecipeFileSelectError, [name]: "" });
    // if (action === "Edit") {
    //   setIsUpdImageChanged(true);
    // }
    let fileSize = file?.size;
    fileSize = fileSize / 1048576;
    if (fileSize > 2) {
      // setOnFileSelectError({ error: "File size cannot exceed more than 1MB" });
      enqueueSnackbar("File size cannot exceed more than 2MB", {
        anchorOrigin: { vertical: "top", horizontal: "right" },
        variant: "warning",
        autoHideDuration: 3000
      });
    } else {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageData = reader.result;
        setRecipeImage({ ...recipeImage, [name]: imageData });
        // console.log(imageData, "imageDATA");
      };
      reader.readAsDataURL(file);
    }
  };

  const handleStoreSelection = (e) => {
    setSelectedStoresForTest(e)
  };

  const TestActiveDialog = () => {
    return (
      <>
        <Dialog
          open={testDialog}
          onClose={handleCloseTestActive}
          style={{ zIndex: "999", minHeight: "500px" }}
        >
          <DialogTitle>Test Active Stores</DialogTitle>
          <Divider />
          <DialogContent>
            <Autocomplete
              sx={{ m: 1, width: 500 }}
              multiple
              style={{ zIndex: "9999" }}
              options={storeList}
              getOptionLabel={(option) => `${option?.intRitasStoreID}`}
              onChange={(e, value) => handleStoreSelection(value)}
              disableCloseOnSelect
              value={selectedStoresForTest}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Search Store"
                  placeholder="Search Store"
                />
              )}
              renderOption={(props, option, { selected }) => (
                <MenuItem
                  {...props}
                  key={option?.intRitasStoreID}
                  style={{ zIndex: "99999999" }}
                  value={option}
                  sx={{ justifyContent: "space-between" }}
                >
                  {`${option?.intRitasStoreID}-${option?.vchStoreName}`}
                  {selected ? <CheckCircle color="info" /> : null}
                </MenuItem>
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseTestActive}>Close</Button>
            <Button onClick={handleUpdateTestStores}>Update</Button>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  const handleTestActive = (dataItem) => {
    setSelectedFlavor(dataItem);
    setSelectedStoresForTest(dataItem?.testStores || [])
    setTestDialog(!testDialog);
  };
  const handleCloseTestActive = () => {
    setSelectedFlavor("");
    setTestDialog(false);
  };
  const handleUpdateTestStores = () => {
    const records = [...flavorsList]
    const data = records.map(i => {
      if (i?.intFlavorID === selectedFlavor?.intFlavorID) {
        return { ...i, testStores: selectedStoresForTest }
      } else {
        return { ...i }
      }
    })
    setFlavorsList(data)
    setSelectedFlavor("");
    setTestDialog(false);
    setSelectedStoresForTest([])
  }

  const getFileExtension = (fname) => {
    const extension = fname.substring(fname.lastIndexOf(".") + 1, fname.length);
    return extension;
  };

  const uploadToS3 = async (file) => {
    // console.log("upload TS3", file);
    if (!file) {
      return;
    }
    // setLoading(true);
    let fn = flavorName?.replace(/ /g, "").toLowerCase();
    const artifactFolder = "flavor_icons";
    const params = {
      Bucket: process.env.REACT_APP_AWS_BUCKET,
      Key: `${artifactFolder}/${fn}.${getFileExtension(file.name)}`,
      Body: file,
    };
    const response = await s3.upload(params).promise();
    // console.log("From S3 bucket ::: ", response, "response :::");
    return response;
    // setFileName(response.key);
    // setLoading(false);

    // const iParams = {
    //   Bucket: process.env.REACT_APP_AWS_BUCKET,
    //   Key: response.key,
    // };
    // var url = s3.getSignedUrl("getObject", iParams);
    // setImage(url);
  };

  const getSignedUrl = (file) => {
    return `${file}?rand=${Math.floor(Math.random() * 5557654)}`
    // const imgPath = file?.split("/");
    // // console.log(imgPath, "split");
    // // console.log(file);
    // if(imgPath){
    //   const iParams = {
    //     Bucket: process.env.REACT_APP_AWS_BUCKET,
    //     Key: `${imgPath[3]}/${imgPath[4]}`,
    //   };
    //   var url = s3.getSignedUrl("getObject", iParams);
    //   return url;
    // }
  };

  // const clearImageRefs = (e) => {
  //   // e.preventDefault();
  //   // setFileName("");
  //   setImage("");
  //   imageInputRef.current.value = "";
  // };
  // const clearDTImageRefs = (e) => {
  //   setDTImage("");
  //   dtImageInputRef.current.value = "";
  // };
  // const getImageFromS3 = async (res) => {
  //   const params = {
  //     Bucket: process.env.REACT_APP_AWS_BUCKET,
  //     Key: res.key,
  //   };
  //   try {
  //     const data = await s3.getObject(params).promise();
  //     console.log(data.Body.toString("base64"), "image data :::: ", data);
  //     setImage(data.Body.toString("base64"));
  //     setFileName(res.key);
  //   } catch (error) {
  //     console.error("Get image error:", error);
  //   }
  // };

  const handleManageFlavorSearch = (event) => {
    if (event.target.value !== "") {
      setFlavorSearch(event.target.value);
      searchDelay(params, event.target.value);
    } else {
      setFlavorSearch("");
      setParams({ ...params, ["keyword"]: "" });
    }
  };

  const handleChange = (event, name = "") => {
    setFlavorSearch("");
    const value = event.target.value;
    if (value !== 0) {
      // console.log(value, "etv ::::");
      setParams(prevState => ({ ...prevState, keyword: "", [name]: name === "activeFlag" ? (value === 'active') : value }));
    }
    if (value === 0) {
      // setParams({ ...params, ["productytpe"]: "" });
      setParams(prevState => ({ ...prevState, keyword: "", [name]: name === "activeFlag" ? undefined : 0 }));
    }
  };

  const handleClose = (event, reason) => {
    // setOpen(false);
    if (reason && reason === "backdropClick") return;
    myCloseModal();
  };

  const myCloseModal = () => {
    setOpen(false);
    setRecipeImage(initialRecipe)
  };
  // const handleOpen = () => {
  //   setOpen(true);
  // };

  const flavorActiveChange = (e, active, id) => {
    setActiveStatus(e.target.checked);
    // const newData = update(flavorsList, {
    //   [id]: { [active]: { $set: e.target.checked } },
    // });
    // // flavorsList[id].active = flavor === true ? false : true;
    // console.log(e.target.checked, ":::00000000000000000000000000000");
    // setFlavorsList(newData);
  };

  const changeBitLTO = (e) => {
    setBitLTO(e.target.checked);
  };
  const changeBitDisplayToppingIcon = (e) => {
    setBitDisplayToppingIcon(e.target.checked);
  };
  const changeBitIsOptional = (e) => {
    setBitIsOptional(e.target.checked);
  };
  const changeBitIsNutfree = (e) => {
    setBitIsNutfree(e.target.checked);
  };
  const changeBitIsKosher = (e) =>{
    setBitIsKosher(e.target.checked);
  };
  const changeBitIsCYKosher = (e) =>{
    setBitIsCYKosher(e.target.checked)
  };
  const onSubmit = (e) => {
    e.preventDefault();

    if (!flavorName) {
      setIsLabelFilled("Please enter flavor name");
    } else {
      setIsLabelFilled("");
    }
    if (!productType) {
      setIsSelected("Please select product type");
    } else {
      setIsSelected("");
    }
    if (!receiptName) {
      setIsReceiptFilled("Please enter receipt name");
    } else {
      setIsReceiptFilled("");
    }
    let flavorObj = {};

    if (flavorName && productType && receiptName) {
      setLoading(true);
      flavorObj = {
        flavorName: flavorName,
        intProductTypeID: productType,
        action: action.toLowerCase(),
        receiptName: receiptName,
        image: file,
        DTIcon: dtFile,
        active: activeStatus === true ? true : false,
        quarterContainer: recipeImage.quarterContainer,
        halfContainer: recipeImage.halfContainer,
        singleContainer: recipeImage.singleContainer,
        doubleContainer: recipeImage.doubleContainer,
        bitLTO: bitLTOStatus,
        bitDisplayToppingIcon: bitDisplayToppingIconStatus,
        bitIsOptional: bitIsOptionalStatus,
        bitIsNutfree: bitIsNutfreeStatus,
        bitIsKosher: bitIsKosherStatus,
        bitIsCYKosher: bitIsCYKosherStatus
      };
      if (action?.toLowerCase().replace(/ /g, "") === "edit") {
        flavorObj.flavorID = flavorID;
        flavorObj.imageUrl = imageurl;
        flavorObj.DTIconUrl = dtImageUrl;
        flavorObj.fid = fID;
        flavorObj.bitLTO = bitLTOStatus;
        flavorObj.bitDisplayToppingIcon = bitDisplayToppingIconStatus;
        flavorObj.bitIsOptional = bitIsOptionalStatus;
        flavorObj.bitIsNutfree = bitIsNutfreeStatus;
        flavorObj.bitIsKosher = bitIsKosherStatus;
        flavorObj.bitIsCYKosher = bitIsCYKosherStatus;
        if (recipeImage.halfContainer?.includes('?AWSAccessKeyId')) {
          flavorObj = { ...flavorObj, halfContainer: recipeImage?.halfContainer?.split("?AWSAccessKeyId")[0] }
        }
        if (recipeImage.quarterContainer?.includes('?AWSAccessKeyId')) {
          flavorObj = { ...flavorObj, quarterContainer: recipeImage.quarterContainer?.split("?AWSAccessKeyId")[0] }
        }
        if (recipeImage.doubleContainer?.includes('?AWSAccessKeyId')) {
          flavorObj = { ...flavorObj, doubleContainer: recipeImage?.doubleContainer?.split("?AWSAccessKeyId")[0] }
        }
        if (recipeImage.singleContainer?.includes('?AWSAccessKeyId')) {
          flavorObj = { ...flavorObj, singleContainer: recipeImage.singleContainer?.split("?AWSAccessKeyId")[0] }
        }
        // if (isUpdImagechanged) {
        //   callImageWithCRUDAction(flavorObj);
        // } else {
        callCRUDAction(flavorObj);
        // }
      } else {
        // callImageWithCRUDAction(flavorObj);
        callCRUDAction(flavorObj);
      }
    } else {
      return;
    }
  };

  // const callImageWithCRUDAction = async (flavorObj) => {
  //   const res = uploadToS3(file);
  //   res
  //     .then((data) => {
  //       console.log("results :::", data);
  //       flavorObj.imageURL = data.key;
  //       callCRUDAction(flavorObj);
  //     })
  //     .catch((error) => {
  //       console.log("Error", error);
  //       setLoading(false);
  //     });
  // };

  const handleRecipeCard = (dataItem) => {
    setShowRecipeCards(!showRecipeCards);
    const flavorItem = {
      ...dataItem,
      quarterContainer:
        dataItem?.quarterContainer === ""
          ? dataItem?.quarterContainer
          : getSignedUrl(dataItem?.quarterContainer),
      halfContainer:
        dataItem?.halfContainer === ""
          ? dataItem?.halfContainer
          : getSignedUrl(dataItem?.halfContainer),
      singleContainer:
        dataItem?.singleContainer === ""
          ? dataItem?.singleContainer
          : getSignedUrl(dataItem?.singleContainer),
      doubleContainer:
        dataItem?.doubleContainer === ""
          ? dataItem?.doubleContainer
          : getSignedUrl(dataItem?.doubleContainer),
    };
    setSelectedFlavor(flavorItem);
  };
  const handleCloseRecipeCards = () => {
    setShowRecipeCards(!showRecipeCards);
  };

  const callCRUDAction = async (Obj) => {
    const result = await serviceapi?.flavorCRUDOperations(Obj);
    // console.log(result, "::: result");
    if (result?.statusCode === 200) {
      setIsSelected("");
      enqueueSnackbar(result.message + " ", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      setLoading(false);
      setOpen(false);
      // setFlavors([]);
      setFlavorsList([]);
      getFlavors();
    } else if (result?.statusCode === 201) {
      enqueueSnackbar(result.message + " ", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "success",
      });
      setLoading(false);
      setOpen(false);
      // setFlavors([]);
      setFlavorsList([]);
      getFlavors();
    } else {
      enqueueSnackbar(result.message + " ", {
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      setLoading(false);
    }
  };

  const handleClearRecipeImages = (name) => {
    setRecipeImage({ ...recipeImage, [name]: "" });
  };

  const searchDelay = useCallback(
    debounce((params, val) => {
      // console.log(val, ":: delay val");
      setParams({ ...params, ["keyword"]: val });
    }, 500),
    []
  );

  function debounce(fn, delay) {
    let timer;
    return function () {
      let context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    };
  }

  const clearFilters = () => {
    setFlavorSearch("");
    setParams({ ...params, ["keyword"]: "" });
  };

  return (
    <>
      {showRecipeCards && (
        <RecipeCardPreview
          showRecipeCards={showRecipeCards}
          selectedFlavor={selectedFlavor}
          handleCloseRecipeCards={handleCloseRecipeCards}
        />
      )}
      <Dialog
        maxWidth="sm"
        fullWidth="false"
        // TransitionComponent={Transition}
        sx={{ zIndex: 1000 }}
        PaperProps={{
          style: {
            minWidth: "37%",
            maxWidth: "65%",
            minHeight: "60%",
            maxHeight: "84%",
          },
        }}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>{action} Flavor</DialogTitle>
        <Divider />
        <DialogContent>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            paddingBottom={"2px"}
          >
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <InputLabel id="flavor-label" required size="small">
                  Product Type
                </InputLabel>
                <Select
                  variant="outlined"
                  size="small"
                  labelId="flavor-label"
                  id="flavor-label-modal"
                  error={isSelected ? true : ""}
                  label="producttypes"
                  value={productType}
                  onChange={(e) => {
                    setProductType(e.target.value);
                    setIsSelected("");
                    setRecipeImage(initialRecipe);
                  }}
                >
                  <MenuItem value="">
                    <em>All</em>
                  </MenuItem>

                  {selectFlavor?.map((name) => (
                    <MenuItem value={name?.intProductTypeID}>
                      {name?.product_type_name}
                    </MenuItem>
                  ))}
                </Select>{" "}
                <div style={{ color: "red" }}>
                  {isSelected && <FormHelperText>{isSelected}</FormHelperText>}
                </div>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%", border: "none" }}>
                <TextField
                  size="small"
                  label="Flavor Name"
                  variant="outlined"
                  required
                  error={isLabelFilled ? true : ""}
                  value={flavorName}
                  onChange={(e) => {
                    setFlavorName(e.target.value);
                    setIsLabelFilled("");
                  }}
                />
                <div style={{ color: "red" }}>
                  {isLabelFilled && (
                    <FormHelperText>{isLabelFilled}</FormHelperText>
                  )}
                </div>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <TextField
                  size="small"
                  label="Receipt Name"
                  variant="outlined"
                  required
                  error={isReceiptFilled ? true : ""}
                  value={receiptName}
                  onChange={(e) => {
                    setReceiptName(e.target.value);
                    setIsReceiptFilled("");
                  }}
                />
                <div style={{ color: "red" }}>
                  {isReceiptFilled && (
                    <FormHelperText>{isReceiptFilled}</FormHelperText>
                  )}
                </div>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={activeStatus}
                      onChange={(e) => flavorActiveChange(e)}
                      name="active"
                      label="Active"
                    />
                  }
                  label="Active"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={bitDisplayToppingIconStatus}
                      onChange={(e) => changeBitDisplayToppingIcon(e)}
                      name="displayToppingIcon"
                    />
                  }
                  label="Display Topping Icon"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={bitLTOStatus}
                      onChange={(e) => changeBitLTO(e)}
                      name="active"
                    />
                  }
                  label="LTO (Disables DMB and DT)"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={bitIsOptionalStatus}
                      onChange={(e) => changeBitIsOptional(e)}
                      name="optional"
                      label="Optional"
                    />
                  }
                  label="Optional"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={bitIsNutfreeStatus}
                      onChange={(e) => changeBitIsNutfree(e)}
                      name="nutfree"
                      label="NutFree"
                    />
                  }
                  label="NutFree"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={bitIsKosherStatus}
                      onChange={(e) => changeBitIsKosher(e)}
                      name="kosher"
                      label="Kosher"
                    />
                  }
                  label="Kosher"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <FormControl sx={{ m: 1, minWidth: "95%" }}>
                <FormControlLabel
                  sx={{ pl: 2 }}
                  control={
                    <Switch
                      checked={bitIsCYKosherStatus}
                      onChange={(e) => changeBitIsCYKosher(e)}
                      name="cykosher"
                      label="CY Kosher"
                    />
                  }
                  label="CY Kosher"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} display={'flex'} alignItems={'center'}>
              <FormControl sx={{ m: 1 }}>
                <label htmlFor="upload-photo">
                  <input
                    style={{ display: "none" }}
                    id="upload-photo"
                    name="upload-photo"
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    // onClick={clearImageRefs}
                    ref={imageInputRef}
                    onChange={(e) => handleFileChange(e, 'flavor')}
                  />

                  <Button
                    color="secondary"
                    style={{ backgroundColor: "#D41042" }}
                    variant="contained"
                    component="span"
                  >
                    Upload Flavor Icon <FileUploadIcon />
                  </Button>
                </label>{" "}
                {/* {onFileSelectError?.flavor && (
                  <FormHelperText>{onFileSelectError?.flavor}</FormHelperText>
                )} */}
              </FormControl>
              <div
                style={{
                  marginLeft: "10px",
                  color: "#000000",
                  fontSize: "11px",
                  letterSpacing: "0.00938em",
                }}
              >
                {image && (
                  <img
                    width="40px"
                    height="40px"
                    src={image}
                    alt="The current file"
                  />
                )}
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={6} display={'flex'} alignItems={'center'}>
              <FormControl sx={{ m: 1 }}>
                <label htmlFor="upload-DT-photo">
                  <input
                    style={{ display: "none" }}
                    id="upload-DT-photo"
                    name="upload-DT-photo"
                    type="file"
                    accept="image/png, image/jpg, image/jpeg"
                    // onClick={clearDTImageRefs}
                    ref={dtImageInputRef}
                    onChange={(e) => handleFileChange(e, 'DT')}
                  />

                  <Button
                    color="secondary"
                    style={{ backgroundColor: "#D41042" }}
                    variant="contained"
                    component="span"
                  >
                    Upload DT Icon <FileUploadIcon />
                  </Button>
                </label>{" "}
                {/* {onFileSelectError?.DT && (
                  <FormHelperText>{onFileSelectError?.DT}</FormHelperText>
                )} */}
              </FormControl>
              <div
                style={{
                  marginLeft: "10px",
                  color: "#000000",
                  fontSize: "11px",
                  letterSpacing: "0.00938em",
                }}
              >
                {dtImage && (
                  <img
                    width="40px"
                    height="40px"
                    src={dtImage}
                    alt="The current dt icon file"
                  />
                )}
              </div>
            </Grid>
          </Grid>
          <hr />
          {productType !== NOVELTY_CUSTARD_CATEGORY && <TableContainer component={Paper} className="pt-2">
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Recipe Card</TableCell>
                  <TableCell>Upload</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productType !== CUSTARD_CATEGORY && productType !== HAND_SCOOPED_CUSTARD_CATEGORY &&
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {"QC"}
                    </TableCell>
                    <TableCell>
                      {recipeImage?.quarterContainer ? (
                        <>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div>
                              <img
                                width="40px"
                                height="40px"
                                src={recipeImage?.quarterContainer}
                                alt="The current file"
                              />
                            </div>
                            <div>
                              <DeleteOutlineSharp
                                color="error"
                                onClick={() =>
                                  handleClearRecipeImages("quarterContainer")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <FormControl sx={{ m: 1, minWidth: "95%" }}>
                          <label htmlFor="qc-upload-photo">
                            <input
                              style={{ display: "none" }}
                              id="qc-upload-photo"
                              name="qc-upload-photo"
                              type="file"
                              accept="image/png, image/jpg, image/jpeg"

                              onChange={(e) =>
                                handleRecipeFileChange(e, "quarterContainer")
                              }
                            />
                            <FileUploadIcon color="info" />
                          </label>{" "}

                        </FormControl>
                      )}
                    </TableCell>
                  </TableRow>}
                {productType !== CUSTARD_CATEGORY && productType !== HAND_SCOOPED_CUSTARD_CATEGORY &&
                  <TableRow
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {"HC"}
                    </TableCell>
                    <TableCell>
                      {recipeImage?.halfContainer ? (
                        <>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div>
                              <img
                                width="40px"
                                height="40px"
                                src={recipeImage?.halfContainer}
                                alt="The current file"
                              />
                            </div>
                            <div>
                              <DeleteOutlineSharp
                                color="error"
                                onClick={() =>
                                  handleClearRecipeImages("halfContainer")
                                }
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <FormControl sx={{ m: 1, minWidth: "95%" }}>
                          <label htmlFor="hc-upload-photo">
                            <input
                              style={{ display: "none" }}
                              id="hc-upload-photo"
                              name="hc-upload-photo"
                              type="file"
                              accept="image/png, image/jpg, image/jpeg"

                              onChange={(e) =>
                                handleRecipeFileChange(e, "halfContainer")
                              }
                            />
                            <FileUploadIcon color="info" />
                          </label>{" "}

                        </FormControl>
                      )}
                    </TableCell>
                  </TableRow>}
                <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {productType !== CUSTARD_CATEGORY && productType !== HAND_SCOOPED_CUSTARD_CATEGORY ? "SC" : <img
                      // className="rounded-full"
                      style={{ width: "20px" }}
                      src={"../assets/icons/recipe-card-icon.png"}
                      alt="recipe"
                    />}
                  </TableCell>
                  <TableCell>
                    {recipeImage?.singleContainer ? (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <img
                              width="40px"
                              height="40px"
                              src={recipeImage?.singleContainer}
                              alt="The current file"
                            />
                          </div>
                          <div>
                            <DeleteOutlineSharp
                              color="error"
                              onClick={() =>
                                handleClearRecipeImages("singleContainer")
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <FormControl sx={{ m: 1, minWidth: "95%" }}>
                        <label htmlFor="sc-upload-photo">
                          <input
                            style={{ display: "none" }}
                            id="sc-upload-photo"
                            name="sc-upload-photo"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"

                            onChange={(e) =>
                              handleRecipeFileChange(e, "singleContainer")
                            }
                          />
                          <FileUploadIcon color="info" />
                        </label>{" "}

                      </FormControl>
                    )}
                  </TableCell>
                </TableRow>
                {productType !== CUSTARD_CATEGORY && productType !== HAND_SCOOPED_CUSTARD_CATEGORY && <TableRow
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    DC
                  </TableCell>
                  <TableCell>
                    {recipeImage?.doubleContainer ? (
                      <>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <div>
                            <img
                              width="40px"
                              height="40px"
                              src={recipeImage?.doubleContainer}
                              alt="The current file"
                            />
                          </div>
                          <div>
                            <DeleteOutlineSharp
                              color="error"
                              onClick={() =>
                                handleClearRecipeImages("doubleContainer")
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <FormControl sx={{ m: 1, minWidth: "95%" }}>
                        <label htmlFor="dc-upload-photo">
                          <input
                            style={{ display: "none" }}
                            id="dc-upload-photo"
                            name="dc-upload-photo"
                            type="file"
                            accept="image/png, image/jpg, image/jpeg"

                            onChange={(e) =>
                              handleRecipeFileChange(e, "doubleContainer")
                            }
                          />
                          <FileUploadIcon color="info" />
                        </label>{" "}

                      </FormControl>
                    )}
                  </TableCell>
                </TableRow>}
              </TableBody>
            </Table>
          </TableContainer>}
        </DialogContent>
        <Divider />
        <DialogActions>
          <Button onClick={myCloseModal}>Close</Button>
          {action === "Add" && <Button onClick={onSubmit}>Add</Button>}
          {action === "Edit" && <Button onClick={onSubmit}>Update</Button>}
        </DialogActions>
      </Dialog>
      <div className="py-6 mt-16">
        <header>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              Flavor Admin
            </h1>
            <div className="flex justify-between mt-2">
              <div>
                <FormControl sx={{ minWidth: 150 }}>
                  <OutlinedInput
                    // size="small"
                    autoComplete="off"
                    style={{
                      fontFamily:
                        "Roboto, 'Open Sans', Verdana, sans-serif, FontAwesome",
                    }}
                    className="bg-white text-xs border rounded border-gray-200"
                    sx={{
                      height: 40,
                      paddingRight: 0,
                      width: 215,
                    }}
                    id="outlined-controlled"
                    placeholder="&#xF002; search for flavor name"
                    name="mflavorSearch"
                    value={flavorSearch}
                    onChange={handleManageFlavorSearch}
                    inputProps={{
                      style: {
                        color: "#000",
                        fontSize: "15px",
                      },
                    }}
                    endAdornment={
                      <InputAdornment>
                        <IconButton
                          onClick={clearFilters}
                          sx={{
                            visibility: flavorSearch ? "visible" : "hidden",
                          }}
                        >
                          <ClearIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <FormControl sx={{ minWidth: 200, mr: 1.5, ml: 1.5 }}>
                  <InputLabel htmlFor="grouped-select" size="small">
                    <Typography variant="subtitle2">Product Type</Typography>
                  </InputLabel>
                  <Select
                    defaultValue={0}
                    onChange={(e) => handleChange(e, 'productID')}
                    id="grouped-select"
                    label="Grouping"
                    size="small"
                    style={{ backgroundColor: "#FFF" }}
                  >
                    <MenuItem value={0}>All</MenuItem>
                    {selectFlavor?.map((name) => (
                      <MenuItem value={name?.intProductTypeID}>
                        {name?.product_type_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl sx={{ minWidth: 125, mr: 1 }}>
                  <InputLabel htmlFor="active-filter-select" size="small">
                    <Typography variant="subtitle2">Active/Inactive</Typography>
                  </InputLabel>
                  <Select
                    defaultValue={'active'}
                    onChange={(e) => handleChange(e, 'activeFlag')}
                    id="active-filter-select"
                    label="Active/Inactive"
                    size="small"
                    style={{ backgroundColor: "#FFF" }}
                  >
                    <MenuItem value={0}>All</MenuItem>
                    <MenuItem value={'active'}>Active</MenuItem>
                    <MenuItem value={'inactive'}>Inactive</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div>
                <button
                  size="small"
                  style={{ marginRight: "10px", height: "38px" }}
                  onClick={handleDownload}
                  className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
                >
                  Download File
                </button>{" "}
                <button
                  style={{ height: "38px" }}
                  type="button"
                  onClick={() => callActions("Add", "")}
                  className="inline-flex items-center justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary-light focus:ring-offset-2 sm:w-auto"
                >
                  Add Flavor
                </button>
              </div>
            </div>
          </div>
        </header>
        <main>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="px-4 py-4 sm:px-0">
              {flavorLoading ? (
                <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                  <FlavorTabShimmer />
                </div>
              ) : (
                <div className="rounded-md bg-white shadow-md">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full align-middle md:px-6 lg:px-8">
                      <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <table className="min-w-full divide-y divide-gray-300">
                          <thead className="bg-gray-50">
                            <tr>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Product Type ID
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Product Type Name
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Flavor ID
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Flavor Name
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                LTO
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Optional
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Receipt Name
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Recipe Cards
                              </th>
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Status
                              </th>
                              {/* <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Test Status
                              </th> */}
                              <th
                                scope="col"
                                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 w-6 table-header-color"
                              >
                                Action
                              </th>
                            </tr>
                          </thead>

                          <tbody className="divide-y divide-gray-200 bg-white">
                            {flavorsList.length ? (
                              <>
                                {flavorsList?.map((flvor, ind) => {
                                  return (
                                    <tr key={flvor.flavor_key}>
                                      <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500 sm:pl-6">
                                        <div className="text-gray-700">
                                          {flvor?.intProductTypeID}
                                        </div>
                                      </td>

                                      <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                        <div className="text-gray-700">
                                          {flvor?.product_type_name}
                                        </div>
                                      </td>
                                      <td className="whitespace-nowrap  py-1 text-sm text-gray-500 px-3 ">
                                        <div className="text-gray-700">
                                          {flvor?.intFlavorID}
                                        </div>
                                      </td>
                                      <td
                                        className="whitespace-nowrap py-1 text-sm text-gray-500 px-3 "
                                        title={flvor?.flavor_name}
                                      >
                                        <div className="text-gray-700 flex items-center">
                                          <img
                                            className="rounded-full mr-2"
                                            src={`${flvor?.thumbnailURL}?rand=${Math.floor(Math.random() * 5557654)}`}
                                            onError={(event) => {
                                              event.target.src = "./assets/icons/circle.png";
                                              event.onerror = null;
                                            }}
                                            alt="flvimage"
                                            width={28}
                                          />
                                          {flvor?.flavor_name.length > 30
                                            ? `${flvor?.flavor_name.substring(0, 30)}...`
                                            : flvor?.flavor_name}
                                        </div>
                                      </td>
                                      <td className="whitespace-nowrap  py-1 text-sm text-gray-500 px-3 ">
                                        <div className="text-gray-700">
                                          {flvor?.bitLTO === true
                                            ? "True"
                                            : "False"}
                                        </div>
                                      </td>
                                      <td className="whitespace-nowrap px-3 py-1 text-sm text-gray-500">
                                        <div className="text-gray-700">
                                          {flvor?.bitIsOptional == true
                                          ? "True"
                                          : "False"}
                                        </div>
                                      </td>
                                      <td
                                        className="whitespace-nowrap  py-1 text-sm text-gray-500 px-3 "
                                        title={flvor.receiptName}
                                      >
                                        <div className="text-gray-700">
                                          {flvor?.receiptName.length > 20
                                            ? `${flvor?.receiptName.substring(
                                              0,
                                              20
                                            )}...`
                                            : flvor?.receiptName}
                                        </div>
                                      </td>
                                      <td className="relative whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-7">
                                        <span
                                          style={{ cursor: "pointer" }}
                                          variant="contained"
                                          onClick={() =>
                                            handleRecipeCard(flvor)
                                          }
                                          className="text-primary hover:text-primary-dark flex-justify-center"
                                        >
                                          <PreviewRounded />
                                        </span>
                                      </td>
                                      <td className="whitespace-nowrap  px-3 py-1 text-sm text-gray-500">
                                        <div className="text-gray-700">
                                          {flvor?.activeFlag === true
                                            ? "Active"
                                            : "Inactive"}
                                        </div>
                                      </td>
                                      {/* <td className="relative whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-7">
                                        <span
                                          style={{ cursor: "pointer" }}
                                          variant="contained"
                                          onClick={() =>
                                            handleTestActive(flvor)
                                          }
                                          className="btn btn-link text-primary hover:text-primary-dark"
                                        >
                                          {flvor?.testStores?.length > 0 ? "Active":"Inactive"}
                                        </span>
                                      </td> */}
                                      <td className="relative whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-7">
                                        <span
                                          style={{ cursor: "pointer" }}
                                          variant="contained"
                                          onClick={() =>
                                            callActions("Edit", flvor)
                                          }
                                          className="text-primary hover:text-primary-dark"
                                        >
                                          <EditIcon />
                                          {/* <span className="sr-only">
                                        , {flvor?.flavor_name}
                                      </span> */}
                                        </span>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </>
                            ) : (
                              <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-2 p-2">
                                No flavors found
                              </div>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>
        {testDialog && TestActiveDialog()}
      </div>
    </>
  );
}

export default ManageFlavors;